
<sm-table #outlineTable class="height500" [data]="table" [allowRowDrag]=true [rowDragManaged]=false [dropDraggedRow]="dropDraggedRow" (onCellClicked)="cellClicked($event)">
</sm-table>